import MobileLayout from "@/layouts/MobileLayout";
import ROUTE_NAME from "@/router/router.const";

export default {
  path: "/mobile",
  name: ROUTE_NAME.MOBILE_LAYOUT,
  component: MobileLayout,
};
